import React, { useState } from "react";
import { BookOpen, ChevronUp } from "lucide-react";

/** Sources stay out of the way until a member asks for them. */
export const SourcePanel = ({ label = "Where this data comes from", items = [], testId = "source-panel" }) => {
  const [open, setOpen] = useState(false);
  const lines = items.filter(Boolean);
  if (!lines.length) return null;
  return (
    <div data-testid={testId}>
      <button onClick={() => setOpen(!open)} data-testid={`${testId}-toggle`}
        className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1 text-[11px] font-medium text-slate-600 transition-colors hover:border-sky-200 hover:text-sky-700">
        {open ? <ChevronUp className="h-3 w-3" /> : <BookOpen className="h-3 w-3" />} {open ? "Hide sources" : "Sources"}
      </button>
      {open && (
        <div className="mt-2 space-y-1.5 rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid={`${testId}-body`}>
          <p className="text-[10px] font-mono uppercase tracking-wider text-slate-500">{label}</p>
          {lines.map((line, i) => <p key={i} className="text-[11px] leading-relaxed text-slate-600">{line}</p>)}
        </div>
      )}
    </div>
  );
};

export default SourcePanel;
